import { useMutation } from 'react-query'
import { api } from '../../utils/api'
import { ContentType } from '../../utils/api/tools'
import { AddProductToCartParams } from './order-typed'

export const CART_URL = '/app/cart'

export const CREATE_ORDER_URL = `${CART_URL}/createOrderInCart`

export const useCreateOrder = () => {
  return useMutation(
    async (data: AddProductToCartParams) => {
      return api.belive.post(CREATE_ORDER_URL, data, { contentType: ContentType.JSON })
    },
    {
      onSuccess: () => {
        console.log('create order successful')
      },
      onError: (e: any) => {
        if (e.message) {
          console.log(e.message)
        }
      },
    },
  )
}
